import { createSelector } from "reselect";
import { AB_TEST_STATE } from "./constants";

/**
 * Selects the AB test slice from the state
 * @param state {Record<typeof import('./constants').AB_TEST_STATE, typeof import('./reducer').abTestInitialState>}
 */
export const selectAbTestState = (state) => state[AB_TEST_STATE];

export const selectAbTestRunning = createSelector(
  selectAbTestState,
  (state) => state.running
);

export const selectAbTestVersion = createSelector(
  selectAbTestState,
  (state) => state.version
);
